// Partners — router nested: /partners (list) + /partners/new + /partners/:id/edit.

import { Route, Routes } from 'react-router-dom';
import PartnersList from './PartnersList';
import PartnerEdit from './PartnerEdit';
import PartnerNew from './PartnerNew';

export default function Partners(): JSX.Element {
  return (
    <Routes>
      <Route index element={<PartnersList />} />
      <Route path="new" element={<PartnerNew />} />
      <Route path=":partnerId/edit" element={<PartnerEdit />} />
    </Routes>
  );
}
